<template>
    <div class="field">
        <div class="control has-icons-left">
            <input v-model="lot"
                   v-bind:class="{ 'is-danger': error && error.length > 0 }"
                   class="input"
                   type="text"
                   placeholder="Type Lot Number or Lot ID">
            <span class="icon is-small is-left">
                <i class="fas fa-hashtag"></i>
            </span>
            <p v-if="error && error.length > 0" class="help is-danger">{{ error[0] }}</p>
        </div>
    </div>
</template>

<script>
    export default {
        computed: {
            lot: {
                get: function () {
                    return this.$store.getters.getNewCarLot
                },
                set: function (value) {
                    this.$store.dispatch('setNewCarLot', value)
                }
            },
            error: {
                get: function () {
                    return this.$store.getters.getNewCarErrorLot
                }
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Cars/Create/Inputs/LotInput.vue